import { SelectedReportingPeriodAtom } from "@/store/ReportingPeriodStateAtom";
import { useAtomValue } from "jotai";
import { ReportingPeriodTimeline } from "../reporting-periods";
import { GettingStartedGuide } from "../getting-started-guide/GettingStartedGuide";
import { useDashboardController } from "./useDashboardController";
import { FundDashboard } from "../fund-dashboard/FundDashboard";
import { Loader2 } from "lucide-react";
import { useState, useEffect } from "react";

const LOCAL_STORAGE_KEY = "wealthbee-getting-started-dismissed";

export const Dashboard = () => {
  const selectedReportingPeriod = useAtomValue(SelectedReportingPeriodAtom);
  const controller = useDashboardController();
  const [showGuide, setShowGuide] = useState<boolean>(false);

  // Determine whether to show the guide based on localStorage
  useEffect(() => {
    const isDismissed = localStorage.getItem(LOCAL_STORAGE_KEY) === "true";
    setShowGuide(!isDismissed);
  }, []);

  // Show loading state
  if (controller.isLoading) {
    return (
      <div className="flex items-center justify-center h-[400px]">
        <div className="flex flex-col items-center gap-2">
          <Loader2 className="h-8 w-8 text-primary animate-spin" />
          <p className="text-muted-foreground">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  // Handle dismissing the guide
  const handleDismissGuide = () => {
    setShowGuide(false);
    localStorage.setItem(LOCAL_STORAGE_KEY, "true");
  };

  // If setup is complete, show the fund dashboard
  if (controller.allSetupComplete && !showGuide) {
    return <FundDashboard />;
  }

  // Show getting started guide if setup is not complete or guide hasn't been dismissed
  return <GettingStartedGuide onDismiss={handleDismissGuide} />;
};
